import { createAction } from '@reduxjs/toolkit'
import { ExternalToolLinkParams } from '@repo/shared-types'

export const loadCatalogsAction = createAction('@catalogs/load')
export { appearanceActions, languageActions, stepperActions } from '../slices'

export const externalsActions = {
  openLink: createAction<ExternalToolLinkParams>('@app/externals/openLink'),
}

export const convenienceTestsStepperActions = {
  seeResults: createAction('@users/convenienceTests/seeResults'),
  signTest: createAction('@users/convenienceTests/signTest'),
  goBack: createAction('@users/convenienceTests/goBack'),
  confirm: createAction('@users/convenienceTests/confirm'),
  questionnaire: createAction('@users/convenienceTests/goToQuestionnaire'),
}

export const changePasswordStepperActions = {
  changePassword: createAction('@users/changePassword/update'),
  goBack: createAction('@users/changePassword/goBack'),
  exit: createAction('@users/changePassword/exit'),
}

export const passwordRecoveryStepperActions = {
  checkUser: createAction('@users/passwordRecovery/checkUser'),
  newPassword: createAction('@users/passwordRecovery/newPassword'),
  goBack: createAction('@users/passwordRecovery/goBack'),
  exit: createAction('@users/passwordRecovery/exit'),
}

export const editContactDataActions = {
  updateContactData: createAction('@users/editContactData/updateContactData'),
  editContactData: createAction('@users/editContactData/editContactData'),
  signUpdateContactDataOperation: createAction(
    '@users/editContactData/signUpdateContactDataOperation',
  ),
  goBack: createAction('@users/editContactData/goBack'),
  exit: createAction('@users/editContactData/exit'),
}

export const initializeAppAction = createAction('@app/initializeApp')
